import { TranslateService } from '@ngx-translate/core';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import {
  EventEmitter,
  forwardRef,
  Input,
  Output,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Component } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';
import { TimeFormatPipe } from '../../../../shared/pipes/time-format.pipe';

@Component({
  selector: 'input-select',
  templateUrl: 'inputSelect.component.html',
  styleUrls: ['inputSelect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSelectComponent),
      multi: true,
    },
  ],
})
export class InputSelectComponent
  extends ControlValueAccessorDirective
  implements OnChanges, OnDestroy
{
  @Input() bindValue: any = 'id';
  @Input() bindLabel: any = 'name';
  @Input() multiple: boolean = false;
  @Input() clearable: boolean = false;
  @Input() searchable: boolean = true;
  @Input() readOnlySelect: boolean = false;
  @Input() placeholder: string = '';
  @Input() runServerSideSearch: boolean = false;
  @Input() withEmptyOption: boolean = true;
  @Input() type?: string;
  @Input() timeType: string = '';
  @Input() items!: any[];
  @Input() showIcon: boolean = false;
  @Output() onChangeValue = new EventEmitter();
  @Output() onSearchValue = new EventEmitter();
  @Output() public override onBlur: EventEmitter<string> = new EventEmitter();
  private endSub$ = new Subject();
  searchTerm$ = new Subject<string>();
  searchTerm: string = '';
  noItemFound = 'No items found';
  itemsList: any[] = [];
  showSelect: boolean = true;
  constructor(private translateService: TranslateService) {
    super();
    this.searchTerm$
      .pipe(
        debounceTime(500), // Debounce for 500ms
        distinctUntilChanged() // Only emit if the value has changed
      )
      .subscribe((data) => {
        this.onSearch(data);
      });
    // this.config.notFoundText = this.NoDate;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bindLabel']) {
      this.showSelect = false;
      setTimeout(() => {
        this.showSelect = true;
      }, 50);
    }

    if (changes['items']) {
      this.itemsList = changes['items'].currentValue;
    }
    if (this.itemsList.length > 0 && this.type === 'time') {
      const timeFormatPipe = new TimeFormatPipe();
      this.itemsList = this.itemsList.map((item: any) => ({
        ...item,
        label: timeFormatPipe.transform(
          item[this.bindLabel],
          this.translateService.currentLang
        ),
      }));

      // if(this.timeType === 'to'){

      //   this.itemsList.push ({id: '00:00', val:'00:00' ,
      //    label: timeFormatPipe.transform('00:00' , this.translateService.currentLang )
      //    })
      // }
    }
  }

  // override blur(): void {
  //
  //   this.onBlur.emit();
  // }

  public clearHandler(evt: any) {
    this.searchTerm$.next('');
    this.onChangeValue.emit(this.value);
  }

  public changeValue(val: any) {
    this.onChangeValue.emit(val);
    this.onChange(this.value);
  }

  public onSearch(evt: any) {
    this.searchTerm = evt?.term;
    this.onSearchValue.emit(evt);
  }

  // get getText(){
  //   return this.localizationService.currentLang.includes('en')? 'No Items Found' : 'لا توجد عناصر'
  // }

  ngOnDestroy(): void {
    this.endSub$.next('');
    this.endSub$.complete();
  }

  get NoDate() {
    return 'No items found';
  }
}
